import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FilterDropdown, FilterOptionType, FilterValueType } from './FilterDropdown';
import {
    ArrowIconWrapper,
    FilterDropdownWrapper,
    SearchAndFiltersWrapper,
    SearchIconWrapper,
    SearchInput,
    SearchInputWrapper,
} from './SearchAndFilters.style';
import { GamesPageState } from 'src/domains/casino/components/games/GamesPage.state';

interface SearchAndFiltersGamesListPropsType {
    gamesPageState: GamesPageState;
}

export const SearchAndFiltersGamesList = observer(
    'SearchAndFiltersGamesList',
    (props: SearchAndFiltersGamesListPropsType) => {
        const { gamesPageState } = props;

        return (
            <SearchAndFiltersWrapper>
                <SearchInputWrapper>
                    <SearchInput
                        type='text'
                        placeholder='Search...'
                        value={gamesPageState.searchValue}
                        onChange={gamesPageState.onSearchGame}
                        data-test='all-games-search-input'
                    />
                    <SearchIconWrapper />
                </SearchInputWrapper>

                <FilterDropdownWrapper data-test='all-games-provider-dropdown-select'>
                    <FilterDropdown
                        optionsList={(): Array<FilterOptionType> => gamesPageState.providerFilterOptions}
                        selectedValue={(): FilterValueType => gamesPageState.selectedProviderId}
                        onChangeCallback={gamesPageState.onProviderFilterChange}
                        placeholder='Provider'
                    />
                    <ArrowIconWrapper position='down' />
                </FilterDropdownWrapper>

                <FilterDropdownWrapper>
                    <FilterDropdown
                        optionsList={(): Array<FilterOptionType> => gamesPageState.studioFilterOptions}
                        selectedValue={(): FilterValueType => gamesPageState.selectedStudioId}
                        onChangeCallback={gamesPageState.onStudioFilterChange}
                        placeholder='Studio'
                    />
                    <ArrowIconWrapper position='down' />
                </FilterDropdownWrapper>
            </SearchAndFiltersWrapper>
        );
    }
);
